import { Form, Heading, Inputs, Label, Page, getFieldProps } from '@crx-dev/hss-react-components';
import { makeRequest } from '@crx-dev/hss-react-infrastructure';
import React, { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useGetReturnUrl } from '../../Infrastructure/pageState/useGetReturnUrl';
import { useFormik } from 'formik';
import { useStoreSettings } from '../../Infrastructure/settings/UseStoreSettings';
import { getStoreSettingValue } from '../Common/Helpers/SettingsHelper';
import { useHistory } from 'react-router-dom';
import { useUserInfo } from '../../Infrastructure/auth/UseUserInfo';

function SettingsPage() {
    const userInfo = useUserInfo();
    const returnUrl = useGetReturnUrl() ?? '/';
    const history = useHistory();
    const storeSettings = useStoreSettings();

    const mutation = useMutation<unknown, unknown, any>(item =>
        makeRequest({
            method: 'PUT',
            path: '/api/v1/Settings/addOrUpdateSettings',
            data: { ...item, user: userInfo.name }
        })
    );

    const formik = useFormik({
        initialValues: {
            stockCheckReminderWeeksOverdue:
                getStoreSettingValue(storeSettings.data, 'StockCheckReminderWeeksOverdue') || '1',
            stockCheckReminderIsEnabled:
                getStoreSettingValue(storeSettings.data, 'StockCheckReminderIsEnabled') === 'True' || false
        },
        onSubmit: async values => {
            await mutation.mutateAsync({
                settingType: 'Store',
                settingsValues: {
                    StockCheckReminderIsEnabled: values.stockCheckReminderIsEnabled ? 'True' : 'False',
                    StockCheckReminderWeeksOverdue: values.stockCheckReminderWeeksOverdue
                }
            });
            storeSettings.setIsLoaded(false);
        }
    });

    const onCancel = useCallback(() => {
        history.push(returnUrl);
    }, []);

    return (
        <Page>
            <Page.Header title="Settings" onBackClick={onCancel} />
            <Page.Content>
                <Form onSubmit={formik.handleSubmit}>
                    <Form.Section>
                        <Heading>CD Stock Check Reminder</Heading>
                        <Inputs.Confirmation
                            label="Enable Stock Check Reminders"
                            {...getFieldProps(formik, 'stockCheckReminderIsEnabled')}
                        />
                        <Label label='Mark Stock Checks as overdue after "X" weeks' htmlFor="text2" />
                        <Inputs.Select
                            items={[
                                {
                                    label: '1 Week',
                                    value: '1'
                                },
                                {
                                    label: '2 Weeks',
                                    value: '2'
                                },
                                {
                                    label: '3 Weeks',
                                    value: '3'
                                },
                                {
                                    label: '4 Weeks',
                                    value: '4'
                                }
                            ]}
                            {...getFieldProps(formik, 'stockCheckReminderWeeksOverdue')}
                            disabled={!formik.values.stockCheckReminderIsEnabled}
                        />
                    </Form.Section>
                    <Form.Footer
                        onCancel={onCancel}
                        submitButtonLabel="Confirm"
                        submitError={mutation.isError}
                        isSubmitting={mutation.isLoading}
                    />
                </Form>
            </Page.Content>
        </Page>
    );
}

export default SettingsPage;
